module.exports = __webpack_public_path__ + "static/media/logo.2bddd064.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/logos/springmedical/logo.png
// module id = 427
// module chunks = 0